export const QUESTION_POSITION = [
  { CODE: 'back-end-engineering', TEXT: '后端' },
  { CODE: 'front-end-engineering', TEXT: '前端' },
  { CODE: 'data-science', TEXT: '数据科学' },
  { CODE: 'machine-learning', TEXT: '机器学习' },
  { CODE: 'product-management', TEXT: '产品管理' },
  { CODE: 'behavioral', TEXT: '行为面试' },
]
export const QUESTION_CATEGORY = [
  { CODE: 'Coding & Algorithm', TEXT: 'Coding & Algorithm' },
  { CODE: 'Back-end Knowledge', TEXT: 'Back-end Knowledge' },
  { CODE: 'OOD', TEXT: 'OOD' },
  { CODE: 'Front-end Knowledge', TEXT: 'Front-end Knowledge' },
  { CODE: 'Technical Skills', TEXT: 'Technical Skills' },
  { CODE: 'Programming Skills', TEXT: 'Programming Skills' },
  { CODE: 'Machine Learning Fundamentals', TEXT: 'Machine Learning Fundamentals' },
  { CODE: 'Product Sense and Business Acumen', TEXT: 'Product Sense and Business Acumen' },
  { CODE: 'Product Design', TEXT: 'Product Design' },
  { CODE: 'Strategy thinking', TEXT: 'Strategy thinking' },
  { CODE: 'Analytical Skills', TEXT: 'Analytical Skills' },
  { CODE: 'Machine Learning Knowledge', TEXT: 'Machine Learning Knowledge' },
  { CODE: 'Deep Learning Knowledge', TEXT: 'Deep Learning Knowledge' },
  { CODE: 'Machine Learning Design', TEXT: 'Machine Learning Design' },
  { CODE: 'Behavioral Question', TEXT: 'Behavioral Question' },
]

export const QUESTION_SUB_CATEGORY = [
  { CODE: 'Coding skills', TEXT: 'Coding skills' },
  { CODE: 'Data structure & algorithm', TEXT: 'Data structure & algorithm' },
  { CODE: 'Database', TEXT: 'Database' }, // 原代码的 'Database ' 去掉了空格
  { CODE: 'Python', TEXT: 'Python' },
  { CODE: 'Java', TEXT: 'Java' },
  { CODE: 'API Design', TEXT: 'API Design' },
  { CODE: 'Performance Optimization and Scalability', TEXT: 'Performance Optimization and Scalability' },
  { CODE: 'DevOps and CI/CD', TEXT: 'DevOps and CI/CD' },
  { CODE: 'OOD', TEXT: 'OOD' },
  { CODE: 'HTML/CSS Proficiency', TEXT: 'HTML/CSS Proficiency' },
  { CODE: 'JavaScript/TypeScript Knowledge', TEXT: 'JavaScript/TypeScript Knowledge' },
  { CODE: 'Frameworks and Libraries', TEXT: 'Frameworks and Libraries' },
  { CODE: 'Responsive Design', TEXT: 'Responsive Design' },
  { CODE: 'Statistical Analysis Knowledge', TEXT: 'Statistical Analysis Knowledge' },
  { CODE: 'Data Preprocessing', TEXT: 'Data Preprocessing' },
  { CODE: 'Data Visualization and Reporting', TEXT: 'Data Visualization and Reporting' },
  { CODE: 'Programming Skills', TEXT: 'Programming Skills' },
  { CODE: 'Machine Learning Fundamentals', TEXT: 'Machine Learning Fundamentals' },
  { CODE: 'Product Sense', TEXT: 'Product Sense' },
  { CODE: 'Business Acumen', TEXT: 'Business Acumen' },
  { CODE: 'Model Selection & Evaluation', TEXT: 'Model Selection & Evaluation' },
  { CODE: 'Feature Engineering & Data Preprocessing', TEXT: 'Feature Engineering & Data Preprocessing' },
  { CODE: 'Deep Learning models', TEXT: 'Deep Learning models' },
  { CODE: 'Model Optimization & Hyperparameter Tuning', TEXT: 'Model Optimization & Hyperparameter Tuning' },
  { CODE: 'Machine Learning Design', TEXT: 'Machine Learning Design' },
  { CODE: 'Behavioral Question', TEXT: 'Behavioral Question' },
]

export const QUESTION_DIFFICULTY = [
  { CODE: 'Easy', TEXT: '简单' },
  { CODE: 'Medium', TEXT: '中等' },
  { CODE: 'Hard', TEXT: '困难' },
  { CODE: 'Very Hard', TEXT: '极难' },
]
